import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PlacementTestRulerList from './PlacementTestRulerList';
import PlacementTestRulerListService from '../services/PlacementTestRulerListService';

class PlacementTestRulerListContainer extends Component {

  componentDidMount() {
    PlacementTestRulerListService.init();
  }

  render() {
    return (
      <PlacementTestRulerList
        rulers={toJS(PlacementTestRulerListService.rulers)}
        fetching={PlacementTestRulerListService.fetch.fetching}
        onDelete={PlacementTestRulerListService.handleRemove}
      />
    );
  }
}

export default observer(PlacementTestRulerListContainer);
